import { render, staticRenderFns } from "./NeedsMealsModal.vue?vue&type=template&id=d9e9dab8&lang=pug"
import script from "./NeedsMealsModal.vue?vue&type=script&lang=ts"
export * from "./NeedsMealsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports